import React from "react";

import { gql } from "@apollo/client";
import { Mutation } from "@apollo/client/react/components";

import { OrderObject } from "./../Queries/OrderQuery";
import orderFragments from "./../Queries/graphql/orderFragments";
import orderEventFragments from "./../Queries/graphql/orderEventFragments";
import orderLineFragments from "./../Queries/graphql/orderLineFragments";

import ConvertToOrderBtn from "./ConvertToOrderBtn";

const CONVERT_TO_ORDER = gql`
  mutation convertQuoteToOrder($id: ID!) {
    convertQuoteToOrder(id: $id) {
      order {
        ...OrderFields
        events {
          ...EventQuery
        }
        orderLines {
          ...OrderLineQuery
        }
      }
      errors {
        path
        message
      }
    }
  }
  ${orderFragments.query}
  ${orderEventFragments.query}
  ${orderLineFragments.query}
`;

class ConvertToOrder extends React.Component {
  state = { errors: null };
  render() {
    const { order } = this.props;
    return (
      <Mutation mutation={CONVERT_TO_ORDER} onError={this.onError}>
        {(update, { loading, error }) => (
          <ConvertToOrderBtn order={order} update={update} />
        )}
      </Mutation>
    );
  }

  onError = error => {
    console.log("onError occurred");
    console.log(error);
  };
}

ConvertToOrder.propTypes = {
  order: OrderObject.isRequired
};

export default ConvertToOrder;
